export default __webpack_public_path__ + "static/media/x.877744cf.svg";